// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2024":"8e16189d","3816":"8e16189d","4084":"8e16189d","5822":"8e16189d","8724":"8e16189d","9645":"8e16189d","9807":"8e16189d"}[chunkId] + ".chunk.css";
};